package no.vareflow.web

import no.vareflow.app.core.VareflowCore
import no.vareflow.app.data.local.BrowserKeyValueStore

const val WEB_VERSION = "0.14.1-web"

/** The intro ("Vareflow by Garasjestudio", index.html) stays at least this long, like the phone's splash. */
const val INTRO_MS = 1400

fun main() {
    val start = { seed: String? ->
        val elapsed = (window.performance.now() as Number).toDouble()
        val wait = (INTRO_MS - elapsed).toInt().coerceAtLeast(0)
        setTimeout(wait) {
            val root = El(document.getElementById("app"))
            val core = VareflowCore(BrowserKeyValueStore(), WEB_VERSION, "web", seedProductsJson = { seed })
            WebApp(core, root).render()
        }
    }
    // The product list from the Excel import is bundled next to the page.
    window.fetch("products_148.json")
        .then { response: dynamic -> if (response.ok as Boolean) response.text() else null }
        .then { text: dynamic -> start(text as String?) }
        .catch { _: dynamic -> start(null) }
}
